import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f8bbe3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_2 = { class: "Box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Subtitle" }, "Данные по перевозке", -1))
const _hoisted_4 = { class: "RowFour" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Отработанные часы", -1))
const _hoisted_6 = { class: "RowFour" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Тариф перевозки", -1))
const _hoisted_8 = { class: "RowFour" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Тариф за простой", -1))
const _hoisted_10 = {
  key: 0,
  class: "Box"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Subtitle" }, "Выставление за перевозку", -1))
const _hoisted_12 = { class: "Row" }
const _hoisted_13 = {
  key: 1,
  class: "Box"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Subtitle" }, "Дополнительные услуги при заборе", -1))
const _hoisted_15 = { class: "RowFour mb-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Адрес", -1))
const _hoisted_17 = { class: "Row" }
const _hoisted_18 = { class: "Row" }
const _hoisted_19 = { class: "Row__title" }
const _hoisted_20 = { class: "Row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Количество часов", -1))
const _hoisted_22 = { class: "Row mt-2" }
const _hoisted_23 = {
  key: 2,
  class: "Box"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Subtitle" }, "Дополнительные услуги при доставке", -1))
const _hoisted_25 = { class: "RowFour" }
const _hoisted_26 = { class: "Row__title" }
const _hoisted_27 = { class: "RowFour" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Адрес", -1))
const _hoisted_29 = { class: "Row" }
const _hoisted_30 = { class: "Row" }
const _hoisted_31 = { class: "Row__title" }
const _hoisted_32 = { class: "Row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Количество часов", -1))
const _hoisted_34 = { class: "Row mt-2" }
const _hoisted_35 = { class: "RowFour FontMedium" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Row__title" }, "Общее выставление", -1))
const _hoisted_37 = { class: "Row__title" }
const _hoisted_38 = { class: "Row FontMedium" }
const _hoisted_39 = { class: "Row__title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Row__title italic" }, " * После завершения заказа, общая сумма выставления учитывает НДС ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_ctx.ftlOrder)
    ? (_openBlock(), _createBlock(_component_modal, {
        key: 0,
        class: "xxl",
        title: "Завершение заказа (Указать данные выставления клиенту)",
        loading: _ctx.isLoading,
        "confirm-disabled": _ctx.isLoading,
        scrollable: "",
        onCancel: _ctx.emitCancel,
        onConfirm: _ctx.emitSubmitted
      }, {
        default: _withCtx(() => [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_loader, { class: "primary" })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(_ctx.ftlOrder.auto_duration || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.price ? `${_ctx.state.price} (мин. ${_ctx.state.minimumHour} часа)` : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(_ctx.state.cost ? `${_ctx.state.cost} ₸/час` : '-'), 1)
                  ])
                ]),
                (_ctx.ftlOrder.is_need_car || _ctx.delivery_state.has_downtime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.ftlOrder.is_need_car)
                          ? (_openBlock(), _createBlock(_component_the_input, {
                              key: 0,
                              placeholder: _ctx.paidPricePlaceholder,
                              value: _ctx.delivery_state.paid_price_total,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.delivery_state.paid_price_total) = $event)),
                              "is-invalid": _ctx.state_form$.paid_price_total.$error,
                              "validation-errors": _ctx.state_form$.paid_price_total.$errors
                            }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"]))
                          : _createCommentVNode("", true),
                        (_ctx.delivery_state.has_downtime)
                          ? (_openBlock(), _createBlock(_component_the_input, {
                              key: 1,
                              placeholder: _ctx.downtimePlaceholder,
                              value: _ctx.delivery_state.downtime.paid_price,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.delivery_state.downtime.paid_price) = $event)),
                              "is-invalid": _ctx.state_form$.downtime.paid_price.$error,
                              "validation-errors": _ctx.state_form$.downtime.paid_price.$errors
                            }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.delivery_state.additional_services.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(_ctx.senderAddress || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.additional_services, (service, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `service-${idx}`
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(service.type_name), 1),
                              _createElementVNode("span", null, _toDisplayString(service.value || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _hoisted_21,
                              _createVNode(_component_the_input, {
                                placeholder: "Количество часов",
                                value: service.duration_client,
                                "onUpdate:value": ($event: any) => ((service.duration_client) = $event),
                                "is-invalid": !service.duration_client,
                                type: "number"
                              }, null, 8, ["value", "onUpdate:value", "is-invalid"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_the_input, {
                                placeholder: "Выставление клиенту",
                                value: service.paid_price_total,
                                "onUpdate:value": ($event: any) => ((service.paid_price_total) = $event),
                                "is-invalid": !service.paid_price_total,
                                type: "number"
                              }, null, 8, ["value", "onUpdate:value", "is-invalid"]),
                              _createVNode(_component_the_input, {
                                placeholder: "Выставление за час",
                                value: service.paid_price_per_hour,
                                "onUpdate:value": ($event: any) => ((service.paid_price_per_hour) = $event),
                                "is-invalid": !service.paid_price_per_hour,
                                type: "number"
                              }, null, 8, ["value", "onUpdate:value", "is-invalid"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stocksFiltered && _ctx.stocksFiltered.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stocksFiltered, (stock, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `stock-${idx}`,
                          class: "mb-2"
                        }, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(stock.directionName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("span", null, _toDisplayString(stock.receiver && stock.receiver.address
                                    ? stock.receiver.address
                                    : '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.stock_services, (service, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `stock-service-${idx}`
                              }, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(service.type_name), 1),
                                  _createElementVNode("span", null, _toDisplayString(service.value || '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _createVNode(_component_the_input, {
                                    placeholder: "Количество часов",
                                    value: service.duration_client,
                                    "onUpdate:value": ($event: any) => ((service.duration_client) = $event),
                                    "is-invalid": !service.duration_client,
                                    type: "number"
                                  }, null, 8, ["value", "onUpdate:value", "is-invalid"])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_the_input, {
                                    placeholder: "Выставление клиенту",
                                    value: service.paid_price_total,
                                    "onUpdate:value": ($event: any) => ((service.paid_price_total) = $event),
                                    "is-invalid": !service.paid_price_total,
                                    type: "number"
                                  }, null, 8, ["value", "onUpdate:value", "is-invalid"]),
                                  _createVNode(_component_the_input, {
                                    placeholder: "Выставление за час",
                                    value: service.paid_price_per_hour,
                                    "onUpdate:value": ($event: any) => ((service.paid_price_per_hour) = $event),
                                    "is-invalid": !service.paid_price_per_hour,
                                    type: "number"
                                  }, null, 8, ["value", "onUpdate:value", "is-invalid"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", _hoisted_37, _toDisplayString(`${_ctx.state.finalCost || 0} ₸`), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, " (" + _toDisplayString(_ctx.delivery_state.paid_price_total || 0) + " + " + _toDisplayString(_ctx.delivery_state.downtime.paid_price || 0) + " + " + _toDisplayString(_ctx.state.additionalServiceCost || 0) + ") ", 1)
                ]),
                _hoisted_40
              ], 64))
        ]),
        _: 1
      }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
    : _createCommentVNode("", true)
}